(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["me-breadcrumb"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.me-breadcrumb-scroll').forEach(function (el) {
    var update = function () {
      el.classList.toggle('is-overflowing', el.scrollWidth > el.clientWidth + 1);
    };
    update();
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(el);
  });
  } catch(e) { console.error(e); }
})();

})();
